/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useState } from 'react'
import useSWR from 'swr'
import { fetchSites, Site } from '../services/api'

interface WidgetSiteContextType {
  siteId: string
  siteName: string
  siteCode: string
  setSite: (id: string) => void
}

const WidgetSiteContext = createContext<WidgetSiteContextType | null>(null)

export const useWidgetSite = () => {
  const ctx = useContext(WidgetSiteContext)
  if (!ctx) throw new Error('useWidgetSite must be used within WidgetSiteProvider')
  return ctx
}

// The user picks one thing — a site — so we persist just its id. name and code
// are derived from the fetched sites list, never stored, so they can't go stale.
export const WidgetSiteProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [siteId, setSiteId] = useState(() => localStorage.getItem('wm_site_id') || '')
  const { data } = useSWR('merch-sites', fetchSites, { revalidateOnFocus: false })
  const site = (data?.sites || []).find((s: Site) => s.id === siteId)

  const setSite = (id: string) => {
    setSiteId(id)
    if (id) localStorage.setItem('wm_site_id', id)
    else localStorage.removeItem('wm_site_id')
  }

  return (
    <WidgetSiteContext.Provider
      value={{ siteId, siteName: site?.name ?? '', siteCode: site?.code ?? '', setSite }}
    >
      {children}
    </WidgetSiteContext.Provider>
  )
}
